export default "__VITE_ASSET__EKlgo2Fw__"